// extracted by mini-css-extract-plugin
module.exports = {"weatherDay":"FTzl","daytimeGroup":"FTzn","label":"FTt7"};